var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 8.83301C8.44767 8.83305 10.0342 9.19537 11.1572 9.75684C12.3101 10.3333 12.833 11.0375 12.833 11.667V12.833H0.5V11.667C0.5 11.0375 1.02288 10.3333 2.17578 9.75684C3.29893 9.19526 4.88605 8.83301 6.66699 8.83301ZM6.66699 0.5C7.41832 0.500086 8.13864 0.798802 8.66992 1.33008C9.2012 1.86135 9.49991 2.58168 9.5 3.33301C9.5 4.08445 9.20127 4.80556 8.66992 5.33691C8.13866 5.86809 7.41824 6.16691 6.66699 6.16699C5.91555 6.16699 5.19444 5.86827 4.66309 5.33691C4.13173 4.80556 3.83301 4.08445 3.83301 3.33301C3.83309 2.58176 4.13191 1.86134 4.66309 1.33008C5.19444 0.798725 5.91555 0.5 6.66699 0.5Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/human.50bc08ede976a521273640ad122a528d.svg";
export { ForwardRef as ReactComponent };